import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { OnDemandChannelsModal } from "../OnDemandChannels";
import { useAudioChannel } from "../../../context/AudioChannelContext";
import { useTranslation } from "react-i18next";

export const AudioChannelOptionModal = ({ user }) => {
  const [selectedChannel, setSelectedChannel] = useState("general");
  const { modals, closeModal, switchModals } = useAudioChannel();
  const { t } = useTranslation();

  const translation = t("channel")
  const commonTranslation = translation.common
  const channelTranslation = translation.body.optionDialog

  const handleClose = () => {
    closeModal("audioChannel");
  };

  const handleOpenOnDemandChannels = () => {
    switchModals("audioChannel", "onDemand");
  };
  useEffect(() => {
    if (modals.audioChannel) {
      setSelectedChannel("general");
    }
  }, [modals.audioChannel])

  return (
    <>
      <Dialog
        open={modals.audioChannel}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            m: 2,
            fontFamily: "Karla, sans-serif",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E5E7EB",
            p: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontSize: "1.125rem", fontWeight: 500 }}
          >
            {channelTranslation.header}
            {/* Audio Channels options */}
          </Typography>
          <IconButton
            edge="end"
            onClick={handleClose}
            aria-label="close"
            sx={{ color: "gray" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 2 }}>
          <Box sx={{ my: 2 }}>
            <Typography variant="caption" sx={{ fontWeight: 500 }}>
              {channelTranslation.preferredChannel}
            </Typography>
            <RadioGroup
              value={selectedChannel}
              onChange={(event) => setSelectedChannel(event.target.value)}
              name="channel-options"
            >
              <FormControlLabel
                value="general"
                control={
                  <Radio
                    sx={{
                      color: "#494B83",
                      "&.Mui-checked": { color: "#494B83" },
                    }}
                  />
                }
                label={channelTranslation.general}
              />
              <FormControlLabel
                value="whiteboard"
                control={
                  <Radio
                    sx={{
                      color: "#494B83",
                      "&.Mui-checked": { color: "#494B83" },
                    }}
                  />
                }
                label={channelTranslation.whiteboard}
              />
            </RadioGroup>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                backgroundColor: "#494B83",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#3d3f6d",
                },
              }}
              onClick={handleOpenOnDemandChannels}
            >
              {channelTranslation.onDemand}
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={handleClose}
              sx={{
                backgroundColor: "#494B83",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#3d3f6d",
                },
              }}
            >
              {commonTranslation.close}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <OnDemandChannelsModal user={user} type={selectedChannel} />
    </>
  );
};
